import axios from 'axios';
import { Roboto, Roboto_Condensed, Syncopate } from 'next/font/google';
import Head from 'next/head';
import { useRouter } from 'next/router';
import {
    useCallback,
    useEffect,
    useMemo,
    useState
} from 'react';
import { v4 as uuidv4 } from 'uuid'; // yarn add uuid
import GlobalThemeSetter from "../components/context/GlobalThemeSetter";
import { AuthProvider } from '../components/context/Info';
import redis from '../lib/redis'; // Importa a conexão com Redis
import { allDataHomePage, cards_busca } from '../services/home';
import { blog } from '../services/menus';
import { imoveis_novidades, properties_carrossel, propertiesSpecific, propertiesSpecific1, propertiesTop10, salvaLogs } from '../services/properties';
import { getCompany } from '../services/selectors';
import '../styles/globals.css';
import { formatDate, isColorLight, removerAcentos } from '../utils/FunctionsGlobals';
import { buildCanonical } from '../utils/url';

const robotoCondensed = Roboto_Condensed({ subsets: ['latin'], weight: ['300', '400', '700'], display: 'swap' });
const roboto = Roboto({ subsets: ['latin'], weight: ['300', '700'], display: 'swap' });
const syncopate = Syncopate({ subsets: ['latin'], weight: ['400', '700'], display: 'swap' });

import '../styles/globals.css';


/* ------------------------------------------------------------------
 *  _app.tsx – versão refatorada para eliminar avisos ESLint
 * ------------------------------------------------------------------ */

function MyApp({ Component, props }: any) {
    // console.log(props)
    /* --------------------- ESTADO ---------------------------------- */
    const router = useRouter();
    const asPath = props?.asPath;
    const detailsProperties = props?.imovel;
    const currentBlog = props?.blogs;
    const getPhoto = props?.imovel?.fotos?.find((v: any) => v.destaque === true);
    const canonicalUrl = useMemo(() => buildCanonical(props?.prodOrigin, asPath), [props?.prodOrigin, asPath]);
    const [allDataHome, setAllDataHome] = useState<any>(props?.allDataHome);
    const [site, setSite] = useState<any>(props?.allDataHome?.site);
    const [origem, setOrigem] = useState<any>(props?.prodOrigin);
    const notFound = props?.notFound ?? false;
    const siteCongelado = props?.erro === false || props?.allDataHome?.site?.congelado === true;

    useEffect(() => {
        if(site){
            document.documentElement.style.setProperty('--cor1', site?.cor1 || '#1f1f1f');
            document.documentElement.style.setProperty('--cor2', site?.cor2 || '#77aa4d');
            document.documentElement.style.setProperty('--cor3', site?.cor3 || '#202020');
            document.documentElement.style.setProperty('--cor4', site?.cor4 || '#181818');
            document.documentElement.style.setProperty('--cor5', site?.cor5 || '#ffffff');
            document.documentElement.style.setProperty('--cor6', site?.cor6 || '#000000');
            document.documentElement.style.setProperty('--cor7', site?.cor7 || '#ffffff');
            document.documentElement.style.setProperty('--cor8', site?.cor8 || '#ffffff');
            document.documentElement.style.setProperty('--cor9', site?.cor9 || '#181818');
            document.documentElement.style.setProperty('--cor10', site?.cor10 || '#363636');
            document.documentElement.style.setProperty('--cor11', site?.cor11 || '#1a1a1a');
            document.documentElement.style.setProperty('--cor12', site?.cor12 || '#1a1a1a');
            document.documentElement.style.setProperty('--cor13', site?.cor13 || '#ffffff');
            document.documentElement.style.setProperty('--cor14', site?.cor14 || '#494949');
            document.documentElement.style.setProperty('--cor15', site?.cor15 || '#000000');
            if(isColorLight(site?.cor2)){
                document.documentElement.style.setProperty('--cor_font2', site?.cor11 || '#1a1a1a');
            } else {
                document.documentElement.style.setProperty('--cor_font2', site?.cor13 || '#ffffff');
            }
            if((isColorLight(site?.cor2) && isColorLight(site?.cor5)) || (!isColorLight(site?.cor2) && !isColorLight(site?.cor5))){
                if(isColorLight(site?.cor5)){
                    document.documentElement.style.setProperty('--cor_title', site?.cor11 || '#1a1a1a');
                } else {
                    document.documentElement.style.setProperty('--cor_title', site?.cor13 || '#ffffff');
                }
            } else {
                document.documentElement.style.setProperty('--cor_title', site?.cor2 || '#ffffff');
            }
            if(isColorLight(site?.cor5)){
                document.documentElement.style.setProperty('--cor_font', site?.cor11 || '#1a1a1a');
            } else {
                document.documentElement.style.setProperty('--cor_font', site?.cor13 || '#ffffff');
            }
            if(isColorLight(site?.cor15)){
                document.documentElement.style.setProperty('--cor_font15', site?.cor11 || '#1a1a1a');
            } else {
                document.documentElement.style.setProperty('--cor_font15', site?.cor13 || '#ffffff');
            }
        }
        
        // document.documentElement.style.setProperty('--fonte-principal', 'Avenir LT Std Black, sans-serif');
    }, [site]);

    // 2) 404 SSR – faz o redirect de forma estável (evita hook condicional)
    useEffect(() => {
        if (notFound && asPath !== '/404') {
        router.replace('/404');
        }
    }, [notFound, asPath, router]);

    // 3) Site congelado → página de marketing
    useEffect(() => {
        if (siteCongelado) {
        router.replace('https://mkt.sobressai.com.br/congelado');
        }
    }, [siteCongelado, router]);

    /* --------------------- LOGS  ----------------------------------- */
    const salvaLog = useCallback(async () => {
        try {
        const ipRes = await axios.get<{ ip: string }>('https://api.ipify.org?format=json');
        await salvaLogs(`${origem}${asPath}`, ipRes.data.ip, props?.codsite, origem);
        } catch {
        await salvaLogs(`${origem}${asPath}`, '0', props?.codsite, origem);
        }
    }, [asPath, origem, props?.codsite]);

    // Chama o log quando ativado
    useEffect(() => {
        if (site?.ativa_logs && allDataHome) salvaLog();
    }, [site?.ativa_logs, allDataHome, salvaLog]);

   // extraia a função para poder memorizá-la
    const getInfoSite = useCallback(async () => {
        try {
            const cached = localStorage.getItem('allDataHome');
            if (cached) {
                const data = JSON.parse(cached);
                setAllDataHome(data);
                setSite(data?.site);
                setOrigem(data?.site?.site);
            } else {
                const data = await allDataHomePage(origem, props?.codsite);
                localStorage.setItem('allDataHome', JSON.stringify(data));
                setAllDataHome(data);
                setSite(data?.site);
                setOrigem(data?.site?.site);
            }
        } catch (e) {
            console.error('❌ Erro ao buscar dados:', e);
            salvaLog();
        }
    }, [origem, props?.codsite, salvaLog]); // ✅ dependências corretas

    // efeito
    useEffect(() => {
        if (props?.erro && !allDataHome) getInfoSite();
        else {
            if(allDataHome)
                localStorage.setItem('allDataHome', JSON.stringify(allDataHome));
        }
    }, [props?.erro, allDataHome, getInfoSite]);
   
    let fbPixelInitialized = false;

    useEffect(() => {
        const sendPageView = async () => {
            if (!site?.fb_token_pixel || !site?.fb_id_pixel) return;

            const eventId = uuidv4();

            let clientIp = '';
            try {
                clientIp = (await axios.get<{ ip: string }>('https://api6.ipify.org?format=json')).data.ip;
            } catch {
                try {
                    clientIp = (await axios.get<{ ip: string }>('https://api.ipify.org?format=json')).data.ip;
                } catch {
                    clientIp = '0.0.0.0';
                }
            }

            const getCookie = (name: string) =>
            document.cookie.split('; ').find((r) => r.startsWith(`${name}=`))?.split('=')[1] || '';

            const fbc = getCookie('_fbc');
            const fbp = getCookie('_fbp');

            const eventTime = Math.floor(Date.now() / 1000);

            await axios.post(
            `https://graph.facebook.com/v12.0/${site.fb_id_pixel}/events`,
            {
                data: [
                {
                    event_name: 'PageView',
                    event_time: eventTime,
                    event_id: eventId,
                    action_source: 'website',
                    event_source_url: window.location.href,
                    user_data: {
                    client_ip_address: clientIp,
                    client_user_agent: navigator.userAgent,
                    fbc,
                    fbp,
                    },
                },
                ],
            },
            {
                params: { access_token: site.fb_token_pixel },
            }
            );

            if (site.pixel_facebook_head && !fbPixelInitialized) {
            const { default: ReactPixel } = await import('react-facebook-pixel');
            (ReactPixel as any).init(site.fb_id_pixel, {}, { autoConfig: false });
            fbPixelInitialized = true;

            (ReactPixel as any).track('PageView', {}, { eventID: eventId });

            const handleRouteChange = () => {
                (ReactPixel as any).track('PageView', {}, { eventID: uuidv4() });
            };

            router.events.on('routeChangeComplete', handleRouteChange);

            // Return cleanup correctly here
            cleanup = () => {
                router.events.off('routeChangeComplete', handleRouteChange);
            };
            }
        };

        let cleanup: (() => void) | undefined;

        sendPageView();

        return () => {
            if (cleanup) cleanup();
        };
    }, [
        router.events,
        site?.fb_id_pixel,
        site?.fb_token_pixel,
        site?.pixel_facebook_head,
    ]);

    /* --------------------- HEAD HELPERS ---------------------------- */
    function RenderHeaderDetails() {
        return null;
    }

    function RenderBlogDetails() {
        if(!currentBlog?.id){
            return (
            <Head>
                <Head>
                    <title>Blog - Imóveis</title>
                    <meta name="description" content="Confira nossos artigos sobre o mercado imobiliário" />
                </Head>
            </Head>
            )
        }
        return (
            <Head>
                <title>{currentBlog?.titulo} - Blog</title>
                <meta name="description" content={currentBlog?.texto ? currentBlog?.texto.replace(/<[^>]*>/g, '').substring(0, 160) : ''} />
                <meta name="keywords" content={site?.meta_keywords ? site?.meta_keywords : `Imobiliária, imóveis, imóveis à venda, imóveis em ${site?.Dados?.cidade}`}/>
                <meta property="og:title" content={currentBlog?.titulo} />
                <meta property="og:description" content={currentBlog?.texto ? currentBlog?.texto.replace(/<[^>]*>/g, '').substring(0, 160) : ''} />
                <meta property="og:image" content={currentBlog?.url_foto} />
                <meta property="og:type" content="article" />
                <meta property="og:url" content={typeof window !== 'undefined' ? window.location.href : ''} />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={currentBlog?.titulo} />
                <meta name="twitter:description" content={currentBlog?.texto ? currentBlog?.texto.replace(/<[^>]*>/g, '').substring(0, 160) : ''} />
                <meta name="twitter:image" content={currentBlog?.url_foto} />
                <meta name="author" content={currentBlog?.autor || site?.Dados?.empresa} />
                <meta name="robots" content="index, follow" />
                <link rel="canonical" href={canonicalUrl} />
                <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css" />
                <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "Article",
                    "headline": currentBlog?.titulo,
                    "image": currentBlog?.url_foto,
                    "author": {
                        "@type": "Person",
                        "name": currentBlog?.autor
                    },
                    "publisher": {
                        "@type": "Organization",
                        "name": site?.Dados?.empresa,
                        "logo": {
                        "@type": "ImageObject",
                        "url": "/assets/images/sem_foto.png"
                        }
                    },
                    "datePublished": formatDate(currentBlog?.data_cadastro),
                    "dateModified": formatDate(currentBlog?.data_cadastro),
                    "description": currentBlog?.texto ? currentBlog?.texto.replace(/<[^>]*>/g, '').substring(0, 160) : '',
                    "mainEntityOfPage": {
                        "@type": "WebPage",
                        "@id": typeof window !== 'undefined' ? window.location.href : ''
                    }
                    })
                }}
                />
            </Head>
        )
    }

    function RenderImoveisDetails() {
        const renderOnlyTextFilters = () => {
            let aux = ""
             const { banheiros } = router.query;
            const { dormitorios } = router.query;
            const { suites } = router.query;
            const { vagas } = router.query;
            if(dormitorios && dormitorios != undefined){
                if(dormitorios == "1")
                    aux = " com 1 dormitório"
                else 
                    aux = ` com ${dormitorios} dormitórios`
            } else {
                if(suites && suites != undefined){
                    if(suites == "1")
                        aux = " com 1 suíte"
                    else 
                        aux = ` com ${suites} suítes`
                } else {
                    if(banheiros && banheiros != undefined){
                        if(banheiros == "1")
                            aux = " com 1 banheiro"
                        else 
                            aux = ` com ${banheiros} banheiros`
                    } else {
                        if(vagas && vagas != undefined){
                            if(vagas == "1")
                                aux = " com 1 vaga"
                            else 
                                aux = ` com ${vagas} vagas`
                        }
                    }
                } 
            }
            const resposta = asPath.split("/")
            if(resposta[7]){
                return `Imóvel cod: ${resposta[7]}`
            }
            if(resposta[5] && resposta[5] != "-"){
                return `${decodeURIComponent(resposta[5].replaceAll("-"," "))} ${resposta[3] && resposta[3] != "-" ? ` em ${decodeURIComponent(resposta[3].replaceAll("-"," "))}` : ""}${aux}`
            }

            let resposta_tipo = []
            if(resposta[6])
                resposta_tipo = resposta[6].split("?")
            if(resposta_tipo[0] != "-" && resposta_tipo[0]){
                if(resposta[3] && resposta[3] != "-"){
                    if(resposta[2] == "venda"){
                        return `${decodeURIComponent(resposta_tipo[0].replaceAll("-"," ").replaceAll("Casa", "Casas").replaceAll("Terreno", "Terrenos").replaceAll("Apartamento", "Apartamentos").replaceAll("Sobrado", "Sobrados").replaceAll("Cobertura", "Coberturas").replaceAll("+",", "))} à venda em ${decodeURIComponent(resposta[3].replaceAll("-"," "))}${aux}`
                    } else {
                        if(resposta[2] == "aluguel"){
                            return `${decodeURIComponent(resposta_tipo[0].replaceAll("-"," ").replaceAll("Casa", "Casas").replaceAll("Terreno", "Terrenos").replaceAll("Apartamento", "Apartamentos").replaceAll("Sobrado", "Sobrados").replaceAll("Cobertura", "Coberturas").replaceAll("+",", "))} para alugar em ${decodeURIComponent(resposta[3].replaceAll("-"," "))}${aux}`
                        }
                        if(resposta[2] == "temporada"){
                            return `${decodeURIComponent(resposta_tipo[0].replaceAll("-"," ").replaceAll("Casa", "Casas").replaceAll("Terreno", "Terrenos").replaceAll("Apartamento", "Apartamentos").replaceAll("Sobrado", "Sobrados").replaceAll("Cobertura", "Coberturas").replaceAll("+",", "))} para temporada em ${decodeURIComponent(resposta[3].replaceAll("-"," "))}${aux}`
                        }
                        return `${decodeURIComponent(resposta_tipo[0].replaceAll("-"," ").replaceAll("Casa", "Casas").replaceAll("Terreno", "Terrenos").replaceAll("Apartamento", "Apartamentos").replaceAll("Sobrado", "Sobrados").replaceAll("Cobertura", "Coberturas").replaceAll("+",", "))} em ${site?.Dados.cidade ? decodeURIComponent(site?.Dados.cidade) : null}`
                    }
                }
                return `${decodeURIComponent(resposta_tipo[0].replaceAll("-"," ").replaceAll("Casa", "Casas").replaceAll("Terreno", "Terrenos").replaceAll("Apartamento", "Apartamentos").replaceAll("Sobrado", "Sobrados").replaceAll("Cobertura", "Coberturas").replaceAll("+",", "))} para ${resposta[2]}${aux}`
            }
            if(resposta[3] && resposta[3] != "-"){
                if(resposta[2] == "venda"){
                    return `Imóveis à venda em ${decodeURIComponent(resposta[3].replaceAll("-"," "))}${aux}`
                } else {
                    if(resposta[2] == "aluguel"){
                        return `Imóveis para alugar em ${decodeURIComponent(resposta[3].replaceAll("-"," "))}${aux}`
                    }
                    if(resposta[2] == "temporada"){
                        return `Imóveis para temporada em ${decodeURIComponent(resposta[3].replaceAll("-"," "))}${aux}`
                    }
                    return `Imóveis em ${site?.Dados.cidade ? decodeURIComponent(site?.Dados.cidade) : null}`
                }
            }
            return `Imóveis para ${resposta[2] ? resposta[2] : 'venda'}${aux}`
        };
        const bannerListagem = allDataHome?.allBanners.filter((item: { titulo: string; }) => item.titulo === "listagem");
        const urlBannerListagem = bannerListagem ? bannerListagem.length > 0 ? bannerListagem[0] : null : null;
        const capitalizeFirstLetter = (text: string) => {
            if (!text) return text;
            return text.charAt(0).toUpperCase() + text.slice(1);
        };
        return (
            <Head>
                <title>{renderOnlyTextFilters() ? capitalizeFirstLetter(renderOnlyTextFilters()) : site?.titulo}</title>
                <link rel="preconnect" href={"https://"+site?.site}/>
                <link rel="preconnect" href={"https://www."+site?.site}/>
                <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css" />
                <meta name="description" content={renderOnlyTextFilters() ? capitalizeFirstLetter(renderOnlyTextFilters()) : site?.titulo} />
                <meta name="twitter:title" content={renderOnlyTextFilters() ? capitalizeFirstLetter(renderOnlyTextFilters()) : site?.titulo} />
                <meta name="twitter:description" content={renderOnlyTextFilters() ? capitalizeFirstLetter(renderOnlyTextFilters()) : site?.titulo} />
                <meta property="og:url" content={canonicalUrl} />
                <meta name="robots" content="index, follow" />
                <meta
                    property="og:title"
                    content={renderOnlyTextFilters() ? capitalizeFirstLetter(renderOnlyTextFilters()) : site?.titulo}
                ></meta>
                <link rel="canonical" href={canonicalUrl} />
                <meta
                    property="og:image"
                    content={urlBannerListagem ? urlBannerListagem?.url : "https://fotos.sobressai.com.br/Banner/1722/10526.jpg"}
                ></meta>
                <meta name="twitter:image" content={urlBannerListagem ? urlBannerListagem?.url : "https://fotos.sobressai.com.br/Banner/1722/10526.jpg"} />
            </Head>
        )
    }

    /* --------------------- JSX ------------------------------------- */
    if (siteCongelado || (notFound && asPath !== '/404')) {
        return (
        <div style={{ width: '100%', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <p>Redirecionando...</p>
        </div>
        );
    }

    return (
        <>
        {props?.imovel?.id || asPath.includes("/imovel/") ? RenderHeaderDetails() : currentBlog?.id > 0 ? RenderBlogDetails() : asPath.includes("/imoveis") ? RenderImoveisDetails() : null}
            <main className={`${robotoCondensed.className} ${roboto.className} ${syncopate.className}`}>
                <AuthProvider allDataHome={props.allDataHome} init_props={props}>
                    <GlobalThemeSetter />
                    <Component {...props} />
                </AuthProvider>
            </main>
        </>
    );
}

MyApp.getInitialProps = async (ctx: any) => {
    // Reconstruindo a URL manualmente
    const localOrigin = ctx?.ctx?.req?.rawHeaders[1] || '';
    const asPath = ctx?.ctx?.asPath || ctx?.ctx?.url || '';
    if (asPath === '/null') {
    if (ctx.ctx.res) {
        ctx.ctx.res.writeHead(302, { Location: '/' });
            ctx.ctx.res.end();
            return {}; // Para não continuar executando o restante
        }
    }
    const cloudflareToken = "3UnD4X3RrZhcNcdPId3GHVr0XPRiPUliBlVaa_cT";
    let allDataHome = null;
    let imovel = null;
    let blogs: any = null;
    let all_carrosseis: any = [];
    let codsite = 0;
    let erro = true;
    let prodOrigin = ctx?.ctx?.req?.rawHeaders[1] || ''
    const userAgentString = ctx?.ctx?.req?.headers['user-agent'] || '';
    const isMobile = /Mobile/i.test(userAgentString) || /iPhone/i.test(userAgentString);
    let canonical = prodOrigin
    let allCards: any = [];
    let all_company: any = [];

    if (ctx.ctx.req) {
        // Estamos no servidor
        const req = ctx.ctx.req;
        prodOrigin = req.headers['host'] || '';  // 'host' retorna o domínio do site
        
        const domain = req.headers['host'] || '';
        const ip = req.headers['cf-connecting-ip'] || req.headers['x-forwarded-for']?.split(',')[0]?.trim() || req.socket?.remoteAddress || 'IP desconhecido';
        const userAgent = req.headers['user-agent'] || '';
        const url = ctx?.ctx?.asPath || ctx?.ctx?.url || '';
        const now = new Date().toISOString();
        const country = req.headers['cf-ipcountry'] || 'BR'; // XX para desconhecido

        const { isVerifiedGoogle } = await import('../utils/isVerifiedGoogle');
        
        if (await isVerifiedGoogle(ip, userAgent) || ip == "144.76.9.119" || ip === '::1') {
            // Não aplica bloqueio para esses bots
        } else {
            // --- BLOQUEIO DE ROTAS PROIBIDAS E SALVA NO REDIS ---
            const blockedPaths = [
                /^\/wp-admin/i,
                /^\/wp-content/i,
                /^\/wp-crom/i,
                /^\/wp-includes/i,
                /^\/wp-login\.php/i,
                /^\/config\.php/i,
                /^\/\.env/i,
                /^\/\.git/i,
                /^\/\.htaccess/i,
                /^\/phpmyadmin/i,
                /^\/admin/i,
                /^\/ALFA_DATA/i,
                /^\/login/i,
                /^\/database/i,
                /^\/backup\.zip/i,
                /^\/backup\.tar\.gz/i,
                /^\/dump\.sql/i,
                /^\/dbdump\.sql/i,
                /^\/phpinfo\.php/i,
                /^\/test\.php/i,
                /^\/install\.php/i,
                /^\/setup\.php/i
            ];

            for (const pattern of blockedPaths) {
                if (pattern.test(url)) {
                    if (ip && ip !== 'IP desconhecido') {
                        await redis.setex(`blocked:${ip}`, 900, '1');
                    }
                    // Redireciona para 404
                    if (ctx.ctx.res) {
                        
                        ctx.ctx.res.statusCode = 404;
                        ctx.ctx.res.end('Not Found');
                    }
                    console.log(`[BLOQUEADO] motivo="motivo2" domain="${domain}" ip="${ip}" country="${country}" date="${now}" url="${url}" userAgent="${userAgent}"`);

                    return { props: {notFound: true,allDataHome, imovel, asPath, prodOrigin, all_carrosseis,blogs, codsite, isMobile, erro, canonical,allCards,all_company}};
                }
            }
            
            if (ip && ip != 'IP desconhecido') {
                if (asPath == "/404") {
                    
                    const key = `blocked1:${ip}`;
                    const isBlockedCount = await redis.get(key);

                    if (isBlockedCount) {
                        if (Number(isBlockedCount) >= 10) {
                            await redis.setex(`blocked:${ip}`, 60, '1');

                            try {
                                await axios.post(
                                'https://api.cloudflare.com/client/v4/accounts/a04d3f3a40225f54476be838970a93e6/rules/lists/6a720570c05a4f0392620481a850a7cc/items',
                                [{ip: ip, comment: 'IP acessou mais de 10 páginas que não existem' }],
                                {
                                    headers: {
                                    'Authorization': `Bearer ${cloudflareToken}`,
                                    'Content-Type': 'application/json'
                                    }
                                }
                                );
                            } catch (error: any) {
                                console.log(`[BLOQUEADO] motivo="motivo3" domain="${domain}" ip="${ip}" country="${country}" date="${now}" url="${url}" userAgent="${userAgent}"`);
                                return { props: {notFound: true,allDataHome, imovel, asPath, prodOrigin, all_carrosseis,blogs, codsite, isMobile, erro, canonical,allCards,all_company}};
                            }
                        } else {
                            await redis.incr(key);
                        }
                    } else {
                        // Primeiro acesso: inicia contador e seta expiração para 10 segundos
                        await redis.set(key, '1');
                        await redis.expire(key, 60);
                    }
                } else {
                    const key = `blocked_access:${ip}`;
                    const isBlockedCount = await redis.get(key);

                    if (isBlockedCount) {
                        if (Number(isBlockedCount) >= 50) {
                            // BLOQUEIA
                            await redis.setex(`blocked:${ip}`, 60, '1');
                            try {
                                await axios.post(
                                'https://api.cloudflare.com/client/v4/accounts/a04d3f3a40225f54476be838970a93e6/rules/lists/6a720570c05a4f0392620481a850a7cc/items',
                                [{ip: ip, comment: 'Mais de 50 acessos em 10 segundos'}],
                                {
                                    headers: {
                                    'Authorization': `Bearer ${cloudflareToken}`,
                                    'Content-Type': 'application/json'
                                    }
                                }
                                );
                            } catch (error: any) {
                                console.log(`[BLOQUEADO] motivo="motivo7" domain="${domain}" ip="${ip}" country="${country}" date="${now}" url="${url}" userAgent="${userAgent}"`);
                                return { props: {notFound: true,allDataHome, imovel, asPath, prodOrigin, all_carrosseis,blogs, codsite, isMobile, erro, canonical,allCards,all_company}};
                            }

                            console.log(`[BLOQUEADO] motivo="motivo6" domain="${domain}" ip="${ip}" country="${country}" date="${now}" url="${url}" userAgent="${userAgent}"`);
                            return { props: {notFound: true,allDataHome, imovel, asPath, prodOrigin, all_carrosseis,blogs, codsite, isMobile, erro, canonical,allCards,all_company}};
                        } else {
                            // Só incrementa o contador, não renova TTL
                            await redis.incr(key);
                        }
                    } else {
                        // Primeiro acesso: inicia contador e seta expiração para 10 segundos
                        await redis.set(key, '1');
                        await redis.expire(key, 10);
                    }
                }

                const isBlocked = await redis.get(`blocked:${ip}`);
                if (isBlocked) {
                    // Redireciona para 404
                    if (ctx.ctx.res) {
                        
                        ctx.ctx.res.statusCode = 404;
                        ctx.ctx.res.end('Not Found');
                    }

                    try {
                        await axios.post(
                        'https://api.cloudflare.com/client/v4/accounts/a04d3f3a40225f54476be838970a93e6/rules/lists/6a720570c05a4f0392620481a850a7cc/items',
                        [{ip: ip,comment: 'Ip na lista de bloqueiomo'}],
                        {
                            headers: {
                            'Authorization': `Bearer ${cloudflareToken}`,
                            'Content-Type': 'application/json'
                            }
                        }
                        );
                    } catch (error: any) {
                        console.log(`[BLOQUEADO] motivo="motivo7" domain="${domain}" ip="${ip}" country="${country}" date="${now}" url="${url}" userAgent="${userAgent}"`);
                        return { props: {notFound: true,allDataHome, imovel, asPath, prodOrigin, all_carrosseis,blogs, codsite, isMobile, erro, canonical,allCards,all_company}};
                    }

                    console.log(`[BLOQUEADO] motivo="motivo4" domain="${domain}" ip="${ip}" country="${country}" date="${now}" url="${url}" userAgent="${userAgent}"`);
                    return { props: {notFound: true,allDataHome, imovel, asPath, prodOrigin, all_carrosseis,blogs, codsite, isMobile, erro, canonical,allCards,all_company}};
                } else {
                    if(country != "BR" && userAgent == ""){
                        await redis.setex(`blocked:${ip}`, 900, '1');

                        // Redireciona para 404
                        if (ctx.ctx.res) {
                            
                            ctx.ctx.res.statusCode = 404;
                            ctx.ctx.res.end('Not Found');
                        }

                        try {
                            await axios.post(
                            'https://api.cloudflare.com/client/v4/accounts/a04d3f3a40225f54476be838970a93e6/rules/lists/6a720570c05a4f0392620481a850a7cc/items',
                            [{ip: ip,comment: 'País fora do BR e sem UserAgent'}],
                            {
                                headers: {
                                'Authorization': `Bearer ${cloudflareToken}`,
                                'Content-Type': 'application/json'
                                }
                            }
                            );
                        } catch (error: any) {
                            console.log(`[BLOQUEADO] motivo="motivo7" domain="${domain}" ip="${ip}" country="${country}" date="${now}" url="${url}" userAgent="${userAgent}"`);
                            return { props: {notFound: true,allDataHome, imovel, asPath, prodOrigin, all_carrosseis,blogs, codsite, isMobile, erro, canonical,allCards,all_company}};
                        }

                        console.log(`[BLOQUEADO] motivo="motivo5" domain="${domain}" ip="${ip}" country="${country}" date="${now}" url="${url}" userAgent="${userAgent}"`);
                        return { props: {notFound: true,allDataHome, imovel, asPath, prodOrigin, all_carrosseis,blogs, codsite, isMobile, erro, canonical,allCards,all_company}};
                    }
                }
            }
        }

        console.log(`[ACESSO] domain="${domain}" ip="${ip}" country="${country}" date="${now}" url="${url}" userAgent="${userAgent}"`);
    } else {
        // Estamos no cliente
        prodOrigin = window.location.host;
        prodOrigin = prodOrigin.replace("https://.","").replace("http://.","").replace("novo.","").replace("www.","").split("/")[0];

        const cacheKey1 = `allDataHome`;

        // 🔍 Verifica se os dados já estão no LocalStorage
        const cachedData = localStorage.getItem(cacheKey1);

        if (cachedData) {
            allDataHome = JSON.parse(cachedData); // Converte para objeto antes de usar
            codsite = allDataHome?.site?.id
        }

        if(allDataHome?.carrosseis?.length > 0){
            const cache_all_carrosseis = `all_carrosseis:${allDataHome?.carrosseis?.length}`;

            // 🔍 Verifica se os dados já estão no LocalStorage
            const cache_cache_all_carrosseis_data = localStorage.getItem(cache_all_carrosseis);

            if (cache_cache_all_carrosseis_data) {
                all_carrosseis = JSON.parse(cache_cache_all_carrosseis_data); // Converte para objeto antes de usar
            }
        }

        canonical = prodOrigin

        return { props: {notFound: false,allDataHome, imovel, asPath, prodOrigin, all_carrosseis,blogs, codsite, isMobile, erro, canonical,allCards,all_company}};
    }

    if(prodOrigin.includes("teste.sobressai.com") || localOrigin.includes('teste.sobressai.com') || prodOrigin.includes('143.244.221.227') || localOrigin.includes('143.244.221.227')){
        const path = asPath.split("?codsite=").slice(0)[1];
        codsite = path?.split('&')[0].replace(/[^0-9]/g, '');

        if((codsite == undefined || !codsite) && ctx?.ctx?.req?.rawHeaders[21]){
            const path = ctx?.ctx?.req?.rawHeaders[21].split("?codsite=").slice(0)[1];
            codsite = path?.split('&')[0].replace(/[^0-9]/g, '');
        }
    }

    canonical = prodOrigin

    if (localOrigin.includes('localhost')) {
        return { props: {notFound: false,allDataHome, imovel, asPath, prodOrigin, all_carrosseis,blogs, codsite, isMobile, erro, canonical,allCards,all_company}};
    }

    if(prodOrigin){
        prodOrigin = prodOrigin.replace("https://.","").replace("http://.","").replace("novo.","").replace("www.","").split("/")[0];
        if(codsite && codsite != 0 && codsite != undefined){
            try {
                let cacheKey = `allDataHomePageTestes:${prodOrigin}:${codsite}`;

                // 🔍 Verifica se os dados já estão no Redis
                const cachedData = await redis.get(cacheKey);

                if (cachedData) {
                    allDataHome = JSON.parse(cachedData); // Converte string para objeto
                } else {
                    allDataHome = await allDataHomePage(JSON.stringify(codsite), codsite, prodOrigin.includes("teste.sobressai.com") || prodOrigin.includes('143.244.221.227') ? 'teste' : '');
                    
                    if(allDataHome){
                        codsite = allDataHome?.site?.id

                        if(allDataHome?.site?.congelado == true){
                            erro = false
                            return { props: {notFound: false,allDataHome, imovel, asPath, prodOrigin, all_carrosseis,blogs, codsite, isMobile, erro, canonical}};
                        }
                        // 🏪 Salva os dados no Redis para uso futuro
                        await redis.setex(cacheKey, 60, JSON.stringify(allDataHome));
                    }
                }

                prodOrigin = allDataHome?.site?.site
            } catch (error: any) {
                if (error?.response?.errors) {
                    console.error("🛑 Detalhes do erro:", JSON.stringify(error.response.errors, null, 2));
                }

                allDataHome = await allDataHomePage(JSON.stringify(codsite), codsite, prodOrigin.includes("teste.sobressai.com") || prodOrigin.includes('143.244.221.227') ? 'teste' : '');
                codsite = allDataHome?.site?.id
                prodOrigin = allDataHome?.site?.site

                if(allDataHome?.site?.congelado == true){
                    erro = false
                    return { props: {notFound: false,allDataHome, imovel, asPath, prodOrigin, all_carrosseis,blogs, codsite, isMobile, erro, canonical}};
                }
            }
        } else {
            try {
                const cacheKey = `allDataHomePage1:${prodOrigin}:${codsite}`;

                // 🔍 Verifica se os dados já estão no Redis
                const cachedData = await redis.get(cacheKey);

                if (cachedData) {
                    allDataHome = JSON.parse(cachedData); // Converte string para objeto
                    if(allDataHome){
                        prodOrigin = allDataHome?.site?.site
                        codsite = allDataHome?.site?.id
                    }
                } else {
                    allDataHome = await allDataHomePage(prodOrigin);
                    if(allDataHome){
                        codsite = allDataHome?.site?.id
                        prodOrigin = allDataHome?.site?.site
                        if(allDataHome?.site?.congelado == true){
                            erro = false
                            return { props: {notFound: false,allDataHome: allDataHome, imovel: imovel, asPath: asPath, prodOrigin: prodOrigin, erro: erro, all_carrosseis: all_carrosseis, codsite: codsite, isMobile: isMobile, canonical: canonical }};
                        }
                        // 🏪 Salva os dados no Redis para uso futuro
                        await redis.setex(cacheKey, 60, JSON.stringify(allDataHome));
                    }
                }
            } catch (error: any) {
                if (error?.response?.errors) {
                    console.error("🛑 Detalhes do erro:", JSON.stringify(error.response.errors, null, 2));
                }

                allDataHome = await allDataHomePage(prodOrigin);
                if(allDataHome){
                    prodOrigin = allDataHome?.site?.site
                    codsite = allDataHome?.site?.id
                    await redis.setex(`allDataHomePage_:${prodOrigin}:${codsite}`, 60, JSON.stringify(allDataHome));
                }
            }
        }

        if(erro){
            if(allDataHome?.site?.id > 0){
                const asPathLimpo = asPath?.split("?")
                if(asPathLimpo[0] == "/" || !asPathLimpo[0] || asPathLimpo[0] == "" || asPath == "" || asPath == "/"){
                    if(allDataHome?.carrosseis?.length > 0){
                        const key_carrossel = `all_carrosseis_3${allDataHome?.carrosseis?.length}:${prodOrigin}:${codsite}`

                        const all_carrosseis_cache = await redis.get(key_carrossel);

                        if(all_carrosseis_cache){
                            all_carrosseis = JSON.parse(all_carrosseis_cache);
                        } else {
                            for (const element of allDataHome.carrosseis) {
                                if (element.personalizado) {
                                    let cacheKey = `all_carrosseis${element.id}:${prodOrigin}:${codsite}`;
                                    const imoveisCarrosseis = await redis.get(cacheKey);

                                    if (imoveisCarrosseis) {
                                        const arrays = [element,JSON.parse(imoveisCarrosseis)]
                                        all_carrosseis.push(arrays); // Converte string para objeto
                                    } else {
                                        const resultado = await properties_carrossel( 
                                            element,
                                            '',
                                            prodOrigin,
                                            codsite
                                        );

                                        if(resultado?.imoveis?.imoveis?.length > 3){
                                            const arrays = [element,resultado?.imoveis?.imoveis]
                                            // console.log(arrays)
                                            all_carrosseis.push(arrays);

                                            // 🏪 Salva os dados no Redis para uso futuro
                                            await redis.setex(cacheKey, 60, JSON.stringify(resultado?.imoveis?.imoveis));
                                        }
                                    }
                                } else {
                                    if(element.novidades_semana){
                                        const cacheKey = `imoveis_novidade:${prodOrigin}:${codsite}`;

                                        const imoveisNovidades = await redis.get(cacheKey);

                                        if (imoveisNovidades) {
                                            const arrays = [element,JSON.parse(imoveisNovidades)]
                                            all_carrosseis.push(arrays); // Converte string para objeto
                                        } else {
                                            const resultado = await imoveis_novidades("",prodOrigin, codsite, prodOrigin.includes("teste.sobressai.com") || prodOrigin.includes('143.244.221.227') || localOrigin.includes('143.244.221.227') ? 'teste' : '');
                                          
                                            if(resultado?.imoveis_novidades?.length > 2){
                                                const arrays = [element,resultado?.imoveis_novidades]

                                                all_carrosseis.push(arrays);

                                                // 🏪 Salva os dados no Redis para uso futuro
                                                await redis.setex(cacheKey, 60, JSON.stringify(resultado?.imoveis_novidades));
                                            }
                                        }
                                    } else {
                                        if(element.top_10){
                                            const cacheKey = `properties_top10${element?.id}:${prodOrigin}:${codsite}`;

                                            const imoveisTop10 = await redis.get(cacheKey);

                                            if (imoveisTop10) {
                                                const arrays = [element,JSON.parse(imoveisTop10)]
                                                all_carrosseis.push(arrays); // Converte string para objeto
                                            } else {
                                                const resultado = await propertiesTop10('',prodOrigin, codsite, prodOrigin.includes("teste.sobressai.com") || prodOrigin.includes('143.244.221.227')  ? 'teste' : '')

                                                if(resultado?.imoveis_destaque?.length > 2){
                                                    const arrays = [element,resultado?.imoveis_destaque]

                                                    all_carrosseis.push(arrays);

                                                    await redis.setex(cacheKey, 60, JSON.stringify(resultado?.imoveis_destaque));
                                                }
                                            }
                                        }
                                    }
                                }
                            }

                            if(all_carrosseis?.length > 0){
                                await redis.setex(`all_carrosseis${allDataHome?.carrosseis?.length}:${prodOrigin}:${codsite}`, 60, JSON.stringify(all_carrosseis));
                            }
                        }
                    }

                    if(allDataHome?.site?.cards_busca == true){
                        let cacheKey = `cards_busca:${prodOrigin}:${codsite}`;

                        const cards_buscas = await redis.get(cacheKey);

                        if (cards_buscas) {
                            allCards = JSON.parse(cards_buscas); // Converte string para objeto
                        } else {
                            const allCard = await cards_busca(prodOrigin, codsite, "");
                        
                            if(allCard?.cards_busca?.length > 0) {
                                allCards = allCard?.cards_busca?.filter(
                                    (v: any) => v.url?.length
                                ) || []
                            }

                            if(allCards){
                                // 🏪 Salva os dados no Redis para uso futuro
                                await redis.setex(cacheKey, 900, JSON.stringify(allCards));
                            }
                        }
                    }
                }

                if(asPath.includes("imovel/")){
                    let isShortUrl = false, id = null;
                    const limpo = asPath.split('?')[0]
                    if (/^\/imovel\/\d+/.test(limpo)) {
                        isShortUrl = true;
                        id = asPath.split('/imovel/')[1].split('?')[0].replace(/[^0-9]/g, '');
                         // Se está na URL curta E o imóvel é válido, redirecione para a longa
                    } else if (/^\/imoveis\/[^/]+\/[^/]+\/[^/]+\/[^/]+\/[^/]+\/[^/]+\/imovel\/\d+/.test(asPath)) {
                        // Já está na URL longa/amigável
                        id = asPath.split('/imovel/')[1].split('?')[0].replace(/[^0-9]/g, '');
                    }

                    if (id) {
                        try{
                            let responseImovel
                            if(allDataHome?.site?.ocultar_endereco){
                                const cacheKey = `propertiesSpecific1:${prodOrigin}:${codsite}:${Number(id)}`;

                                const propertiesSpecific11 = await redis.get(cacheKey);

                                if (propertiesSpecific11) {
                                    responseImovel = JSON.parse(propertiesSpecific11); // Converte string para objeto
                                } else {
                                    responseImovel = await propertiesSpecific1(Number(id), prodOrigin, codsite, prodOrigin.includes("teste.sobressai.com") || prodOrigin.includes('143.244.221.227') ? 'teste' : '');

                                    if(responseImovel){
                                        // 🏪 Salva os dados no Redis para uso futuro
                                        await redis.setex(cacheKey, 60, JSON.stringify(responseImovel));
                                    }
                                }
                            } else {
                                const cacheKey = `propertiesSpecific:${prodOrigin}:${codsite}:${Number(id)}`;

                                const propertiesSpecific_aux = await redis.get(cacheKey);

                                if (propertiesSpecific_aux) {
                                    responseImovel = JSON.parse(propertiesSpecific_aux); // Converte string para objeto
                                } else {
                                    responseImovel = await propertiesSpecific(Number(id), prodOrigin, codsite, prodOrigin.includes("teste.sobressai.com") || prodOrigin.includes('143.244.221.227') ? 'teste' : '');

                                    if(responseImovel){
                                        // 🏪 Salva os dados no Redis para uso futuro
                                        await redis.setex(cacheKey, 60, JSON.stringify(responseImovel));
                                    }
                                }
                            }

                            imovel = responseImovel?.imovel;

                            if (isShortUrl && imovel && imovel.id) {
                                // Monte a nova rota igual ao seu component Property
                                const validationModelSale = imovel?.venda ? 'venda' : '';
                                const validationModelRent = imovel?.aluguel ? 'aluguel' : '';
                                const validationModel = validationModelSale || validationModelRent || 'venda';

                                const cidade = imovel?.cidade?.nome?.replaceAll('-', '002D').replaceAll('/', '-').replaceAll("\n", '-') || '-';
                                const bairro = imovel?.bairro?.nome?.replaceAll('-', '002D').replaceAll('/', '-').replaceAll("\n", '-') || '-';
                                const empreendimento = imovel?.empreendimento?.nome
                                ? imovel?.empreendimento?.nome.replaceAll('-', '002D').replaceAll('/', '-').replaceAll("\n", '-')
                                : '-';
                                const tipo = imovel?.tipo?.nome
                                ? imovel?.tipo?.nome.replaceAll('-', '002D').replaceAll('/', '-').replaceAll("\n", '-')
                                : '-';
                                const referencia = imovel?.referencia
                                ? imovel?.referencia.replaceAll('-', '002D').replaceAll('/', '-').replaceAll("\n", '-')
                                : '-';

                                let newPath = `/imoveis/${validationModel}/${cidade}/${bairro}/${empreendimento}/${tipo}/${referencia}/imovel/${imovel.id}`;
                                newPath = removerAcentos(newPath).toLowerCase();
                                newPath = newPath.replaceAll(" ","-").replaceAll("%B4","").replaceAll("´","")
                            
                                // Recupera a query string (tudo que vem após o ?)
                                let queryString = '';
                                if (asPath && asPath.includes('?')) {
                                    queryString = asPath.substring(asPath.indexOf('?')); // Inclui o "?"
                                }

                                // Adiciona a query string ao newPath (se existir)
                                if (queryString) {
                                    newPath += queryString;
                                }

                                if (ctx.ctx.res) {
                                    ctx.ctx.res.writeHead(301, { Location: newPath });
                                    ctx.ctx.res.end();
                                    return {};
                                }
                            } else {
                                if(!imovel?.id){
                                    let newPath = `/imoveis/venda/-/-/-/-`;
                                    if (ctx.ctx.res) {
                                        ctx.ctx.res.writeHead(301, { Location: newPath });
                                        ctx.ctx.res.end();
                                        return {};
                                    }
                                }
                            }
                        } catch (error) {
                            imovel = null;
                            const responseImovel = await propertiesSpecific1(Number(id), prodOrigin, codsite, prodOrigin.includes("teste.sobressai.com") || prodOrigin.includes('143.244.221.227') ? 'teste' : '');
                            imovel = responseImovel?.imovel;
                            //  console.log("error:"+error)
                        
                            if(!imovel?.id){
                                let newPath = `/imoveis/venda/-/-/-/-`;
                                if (ctx.ctx.res) {
                                    ctx.ctx.res.writeHead(301, { Location: newPath });
                                    ctx.ctx.res.end();
                                    return {};
                                }
                            }
                        }
                    }
                } else {
                    if(asPath.includes("imoveis/")){
                        if(allDataHome?.site?.exibir_empreendimento ) {
                            let cacheKey = `all_company:${prodOrigin}:${codsite}`;

                            const company = await redis.get(cacheKey);

                            if (company) {
                                all_company = JSON.parse(company); // Converte string para objeto
                            } else {
                                all_company = await getCompany('',prodOrigin, codsite);

                                if(all_company){
                                    // 🏪 Salva os dados no Redis para uso futuro
                                    await redis.setex(cacheKey, 60, JSON.stringify(all_company));
                                }
                            }
                        }
                    }
                }

                if(asPath.includes("/blog/")){
                    let id = null;
                    const limpo = asPath.split('?')[0]
                    if (/^\/blog\/\d+/.test(limpo)) {
                        id = asPath.split('/blog/')[1].split('?')[0].replace(/[^0-9]/g, '');
                    }

                    if (id) {
                        try{
                            let blog_id
                            const cacheKey = `blogs:${prodOrigin}:${codsite}:${Number(id)}`;

                            const propertiesSpecific_aux = await redis.get(cacheKey);

                            if (propertiesSpecific_aux) {
                                blog_id = JSON.parse(propertiesSpecific_aux); // Converte string para objeto
                            } else {
                                blog_id = await blog(id, prodOrigin,codsite);

                                if(blog_id?.blog?.id){
                                    // 🏪 Salva os dados no Redis para uso futuro
                                    await redis.setex(cacheKey, 60, JSON.stringify(blog_id));
                                }
                            }

                            const blog1 = blog_id?.blog;

                            if (blog1 && blog1?.id) {
                                blogs = blog1
                            } else {
                                if(!blog1?.id){
                                    let newPath = `/blog`;
                                    if (ctx.ctx.res) {
                                        ctx.ctx.res.writeHead(301, { Location: newPath });
                                        ctx.ctx.res.end();
                                        return {};
                                    }
                                }
                            }
                        } catch (error) {
                            console.log("error:"+error)
                        }
                    }
                }

                if (asPath.includes("afiliado/")) {
                const asPathLimpo = asPath?.split("?")
                    const pathArray = asPathLimpo[0].split('/').slice(-2);
                    let id = pathArray[1].replace(/[^0-9]/g, '');
                    if (id) {
                        try{
                            let responseImovel
                            if(allDataHome?.site?.ocultar_endereco){
                                const cacheKey = `propertiesSpecific1:${prodOrigin}:${codsite}:${Number(id)}`;

                                const propertiesSpecific_aux = await redis.get(cacheKey);

                                if (propertiesSpecific_aux) {
                                    responseImovel = JSON.parse(propertiesSpecific_aux); // Converte string para objeto
                                } else {
                                    responseImovel = await propertiesSpecific1(Number(id), prodOrigin, codsite, prodOrigin.includes("teste.sobressai.com") || prodOrigin.includes('143.244.221.227') ? 'teste' : '');

                                    if(responseImovel){
                                        // 🏪 Salva os dados no Redis para uso futuro
                                        await redis.setex(cacheKey, 60, JSON.stringify(responseImovel));
                                    }
                                }
                            } else {
                                const cacheKey = `propertiesSpecific:${prodOrigin}:${codsite}:${Number(id)}`;

                                const propertiesSpecific_aux = await redis.get(cacheKey);

                                if (propertiesSpecific_aux) {
                                    responseImovel = JSON.parse(propertiesSpecific_aux); // Converte string para objeto
                                } else {
                                    responseImovel = await propertiesSpecific(Number(id), prodOrigin, codsite, prodOrigin.includes("teste.sobressai.com") || prodOrigin.includes('143.244.221.227') ? 'teste' : '');

                                    if(responseImovel){
                                        // 🏪 Salva os dados no Redis para uso futuro
                                        await redis.setex(cacheKey, 60, JSON.stringify(responseImovel));
                                    }
                                }
                            }
                            imovel = responseImovel?.imovel;

                            const Array = asPath.split('/').slice(-2);
                            const IdAgenciador = Array[0];
                            if(imovel?.id){
                                let newPath = `/imoveis/venda/-/-/-/-/-/imovel/${imovel?.id}?agenciador=${IdAgenciador}`;

                                // Recupera a query string (tudo que vem após o ?)
                                let queryString = '';
                                if (ctx.asPath && ctx.asPath.includes('?')) {
                                    queryString = ctx.asPath.substring(ctx.asPath.indexOf('?')); 
                                }

                                // Adiciona a query string ao newPath (se existir)
                                if (queryString) {
                                    newPath += queryString;
                                }

                                if (ctx.ctx.res) {
                                    ctx.ctx.res.writeHead(301, { Location: newPath });
                                    ctx.ctx.res.end();
                                    return {};
                                }
                            } else {
                                let newPath = `/imoveis/venda/-/-/-/-`;

                                if (ctx.ctx.res) {
                                    ctx.ctx.res.writeHead(301, { Location: newPath });
                                    ctx.ctx.res.end();
                                    return {};
                                }
                            }
                        } catch (error) {
                            imovel = null;
                        }
                    }
                }
            }
        }
    }

    codsite = allDataHome?.site?.id || 0
    
    return { props: {notFound: false,allDataHome, imovel, asPath, prodOrigin, all_carrosseis,blogs, codsite, isMobile, erro, canonical,allCards,all_company}};
};

export default MyApp;
